import { useCallback, useMemo } from 'react';
import { initialActiveCategory } from '../config';
import { NavigationCategory, NavigationSection } from '../types';
import { useDrawerContext } from '../context';

type UseDrawerToggleCategoryResult = {
  activeCategory: NavigationCategory;
  activeWithSelectionCategories: NavigationCategory[];
  navigationSections: NavigationSection[];
  toggleCategory: (newCategory: NavigationCategory) => void;
};

const useDrawerToggleCategory = (): UseDrawerToggleCategoryResult => {
  const {
    isSearching,
    isLoading,
    activeCategory,
    activeWithSelectionCategories,
    navigationSections,
    setSearchValue,
    setLoading,
    setActiveCategory,
  } = useDrawerContext();

  const toggleCategory = useCallback(
    (newCategory: NavigationCategory): void => {
      if (activeCategory.value === newCategory.value) {
        setActiveCategory(initialActiveCategory);
      } else {
        setActiveCategory(newCategory);
      }

      if (isSearching) {
        setSearchValue('');
      }

      if (isLoading) {
        setLoading(false);
      }
    },
    [isLoading, isSearching, activeCategory]
  );

  return useMemo(
    () => ({
      activeCategory,
      activeWithSelectionCategories,
      navigationSections,
      toggleCategory,
    }),
    [activeCategory, activeWithSelectionCategories, navigationSections, toggleCategory]
  );
};

export default useDrawerToggleCategory;
